import {createStore} from 'vuex'
import axios from 'axios'

axios.defaults.baseURL = 'https://buisnes-canvas.backend.viracocha.ru/'
//axios.defaults.baseURL = 'http://localhost/'

export const store = createStore({
    state() {
        return {
            token: localStorage.getItem('token') || null,
            template: null,
            values: {}
        }
    },
    getters: {
        isAuthenticated: state => !!state.token,
        getValue: (state) => (id) => {
            return state.values[id]
        }

    },
    actions: {
        async register({commit}, email) {
            try {
                let response = await axios.post('/api/register/', {email: email})
                if (!response.data['is_error']) {
                    commit('login', response.data.token)
                }
                return response.data
            } catch (err) {
                console.log(err)
            }
        },
        async login(context, payload) {
            try {
                let response = await axios.post('/api/login/', {email: payload.email, password: payload.password})
                if (response.status === 200) {
                    context.commit('login', response.data.token)
                    await context.dispatch('getTemplateValues', context.state.template.id)
                }
                return response.data
            } catch (err) {
                return err.response.data
            }
        },
        async logout(context) {
            try {
                let response = await axios.post('/api/logout/')
                if (response.status === 200) {
                    context.commit('logout')
                }
                await context.dispatch('getCurrentTemplate')
                return response.data
            } catch (err) {
                context.commit('logout')
                return err.response.data
            }
        },
        async forgotPassword(context, payload) {
            try {
                let response = await axios.post('/api/forgot-password/', {email: payload.email})
                return response.data
            } catch (err) {
                return err.response.data
            }
        },
        async checkPasswordCode(context, payload) {
            try {
                let response = await axios.post('/api/check-password-code/', {code: payload.code})
                return response.data
            } catch (err) {
                return err.response.data
            }
        },
        async resetPassword(context, payload) {
            try {
                let response = await axios.post('/api/reset-password/',
                    {
                        code: payload.code,
                        password: payload.password,
                        password_confirmation: payload.password_confirmation
                    })
                if (response.status === 200) {
                    await context.commit('login', response.data.token)
                    await context.dispatch('getTemplateValues', context.state.template.id)
                }
                return response.data
            } catch (err) {
                return err.response.data
            }
        },
        async registration(context, payload) {
            try {
                let response = await axios.post('/api/registration/',
                    {
                        email: payload.email,
                        password: payload.password,
                        password_confirmation: payload.password_confirmation
                    })
                if (response.status === 200) {
                    context.commit('login', response.data.token)
//                    await context.dispatch('getTemplateValues', context.state.template.id)
                }
                return response.data
            } catch (err) {
                return err.response.data
            }
        },
        async checkToken(context, token) {
            try {
                let response = await axios.post(
                    '/api/check-token/',
                    {},
                    {
                        headers: {
                            'Authorization': 'Bearer ' + token
                        }
                    })
                if (!response.data['is_error']) {
                    return true
                }
                return false
            } catch (err) {
                console.log(err)
                return false
            }
        },
        async getCurrentTemplate({commit}) {
            try {
                let response = await axios.post('/api/default-template/');
                commit('setTemplate', response.data.data)
                for (let i = 0; i < response.data.data.cells.length; i++) {
                    commit('setValue', {id: response.data.data.cells[i].id, value: response.data.data.cells[i].hint})
                }
                return response.data.data;
            } catch (err) {
                console.log(err)
            }
        },
        async saveCurrentTemplateValues({state}) {
            try {
                let response = await axios.post('/api/save-template-values/' + state.template.id, state.values);
                return response.data.data;
            } catch (err) {
                console.log(err)
            }
        },
        async getTemplateValues({commit}, template_id) {
            try {
                commit('setValues', {})
                let response = await axios.post('/api/get-template-values/' + template_id);
                for (let i = 0; i < response.data.data.length; i++) {
                    commit('setValue', {id: response.data.data[i].id, value: response.data.data[i].value})
                }
                return response.data.data;
            } catch (err) {
                console.log(err)
            }
        },
        async getCurrentTemplateValues(context) {
            try {
                let response = await axios.post('/api/get-template-values/' + context.state.template.id);
                if (response.data.data.length>0)
                {
                    context.commit('setValues', {})
                    for (let i = 0; i < response.data.data.length; i++) {
                        context.commit('setValue', {id: response.data.data[i].id, value: response.data.data[i].value})
                    }
                }
                return response.data.data;
            } catch (err) {
                console.log(err)
            }
        },
        async checkQuery(context, query) {
            if (query['user']) {
                if (!context.state.token) {
                    try {
                        let res = await context.dispatch('checkToken', query['user'])
                        if (res) {
                            context.commit('login', query['user'])
                            await context.dispatch('getTemplateValues', context.state.template.id)
                        }
                    } catch (err) {
                        console.log(err)
                    }
                }
            }
        },

    },
    mutations: {
        login(state, token) {
            state.token = token
            localStorage.setItem('token', token)
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
        },
        logout(state) {
            state.token = null
            localStorage.removeItem('token')
            delete axios.defaults.headers.common['Authorization']
            state.values = {}
        },
        setTemplate(state, template) {
            state.template = template
        },
        setValue(state, payload) {
            state.values[payload.id] = payload.value
        },
        setValues(state, values) {
            state.values = values
        }
    }

})

